import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";

export const EmailCell = <T extends { email: string | null }>({
    row,
}: CellContext<ViewTableFeatures, T, string>) => {
    const email = row.original.email;

    if (!email) {
        return null;
    }

    return <span>{email}</span>;
};
